import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_REPORTING_URL, RESERVATION_BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class DealerReportingClient {
  static baseUrl = RESERVATION_BASE_URL;
  static reportingUrl = BASE_REPORTING_URL;

  static downloadDealerReservationReport(user, lang) {
    let commonIds;

    if (user.getCommonIdsWithSDLR) {
      const dealerIds = user.getCommonIdsWithSDLR();
      commonIds =
        dealerIds && dealerIds.trim() !== ""
          ? dealerIds.split("%7C").join("|")
          : user.commonId;
    } else {
      commonIds = user.commonId;
    }

    // Ensure we have valid common IDs
    if (!commonIds) {
      return Promise.reject(new Error("No valid common IDs available"));
    }

    const requestBody = {
      marketId: user.market,
      commonIds: commonIds,
      langCode: lang,
    };

    const url = `${this.reportingUrl}/reporting/dealer/img-reservations-report`;
    return axios
      .post(url, requestBody, getHeaders())
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }

        return Promise.reject(error);
      });
  }
}
